/**
 * @module Root
 * @copyright 1994-2017 T-Mobile US, Inc. All Rights Reserved.
 */ /** */
// Core Libraries
import { Component, OnDestroy } from '@angular/core';
import { PdlWrapperService } from '@core/services/pdl-wrapper.service';
import { SETTINGS, CHANNELS, GPC_CONSTS } from '@environment/settings';

/**
 * Root Component Abstract Class, used to define the property of the various root components for all channels
 * @access private
 * @abstract
 */
@Component({
  template: '',
})
export abstract class RootComponent implements OnDestroy {
  public abstract loading: boolean;
  constructor(public pdlWrapperService: PdlWrapperService) {
    if (SETTINGS.CHANNEL.toLocaleLowerCase() === CHANNELS.WEB) {
      this.setGpcCookie();
    } else {
      this.loadTealium();
    }
  }

  /**
   * ngOnDestroy component life cycle hook called to unsubscribe the bounded objects
   * @returns void
   */
  public ngOnDestroy(): void {}

  /**
   * Function to set GPC cookie for privacy browsers
   * @returns void
   */
  public setGpcCookie(): void {
    const isGpcEnabled =
      window[GPC_CONSTS.NAVIGATOR] && window[GPC_CONSTS.NAVIGATOR][GPC_CONSTS.GPC];
    if (isGpcEnabled && this.getCookie(GPC_CONSTS.COOKIE_NAME) !== '1') {
      this.setCookie(GPC_CONSTS.COOKIE_NAME);
      window[GPC_CONSTS.GPC_VAR] = true;
    }
    this.loadAdobe();
  }

  /**
   * Function to get the cookie value
   * @param cookieName Stores the name of the cookie
   * @returns string
   */
  public getCookie(cookieName: string): string {
    const match = document.cookie.match(new RegExp(`${cookieName}=([^;]+)`));
    if (match) {
      return match[1];
    }
  }

  /**
   * Function to get the cookie value
   * @param cookieName Stores the name of the cookie
   */
  public setCookie(cookieName: string): void {
    const localDoNotSell = 1;
    const expirationTime = 1;
    const CookieDate = new Date();
    CookieDate.setFullYear(CookieDate.getFullYear() + expirationTime);
    document.cookie = `${cookieName}=${localDoNotSell};expires=${CookieDate.toUTCString()};domain=t-mobile.com`;
  }

  /**
   * Event for when the rendering load is completed
   * @param loading
   * @returns void
   */
  public loadComplete(loading: boolean): void {
    this.loading = loading;
  }

  private loadTealium(): void {
    this.loading = false;
    if (SETTINGS.PDL_ENABLED && SETTINGS.PDL_UTAG_URL) {
      // tslint:disable:no-global-variables
      // tslint:disable-next-line:no-string-literal
      // window['utag_cfg_ovrd'] = {noview : true};
      const headTag = document.getElementsByTagName('head')[0];

      // tslint:disable:no-global-variables
      const scriptTag = document.createElement('script');
      scriptTag.setAttribute('type', 'text/javascript');
      scriptTag.async = true;
      scriptTag.src = SETTINGS.PDL_UTAG_URL;
      headTag.appendChild(scriptTag);
      scriptTag.onload = () => {
        this.loading = false;
        this.pdlWrapperService.pdlSetCaptureEventObservable.next();
      };
    }
  }

  private loadAdobe(): void {
    if (document.querySelector('#adobe-launch')) {
      this.loadSatellite();
      this.loadTealium();
    } else {
      this.loadTealium();
    }
  }
  private loadSatellite(): void {
    const scriptTag = document.createElement('script');
    scriptTag.setAttribute('type', 'text/javascript');
    scriptTag.textContent = `if (_satellite && typeof(_satellite) !== 'undefined') { _satellite.pageBottom(); }`;
    scriptTag.onload = () => {
      console.log('Satellite injected');
    };
    document.body.appendChild(scriptTag);
  }
}
